var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4772_11659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66845e-05 0.697892C7.03141e-05 0.329712 0.298543 0.03125 0.666723 0.03125H15.3333C15.7015 0.03125 16 0.329727 16 0.697917V2.22301C16 2.38931 15.9389 2.55038 15.8234 2.67501C14.1662 4.46349 11.404 7.51149 10.5292 8.47782C10.4605 8.55376 10.4094 8.6423 10.378 8.73797C10.3767 8.7421 10.3754 8.7462 10.3741 8.75026C10.3526 8.81981 10.3414 8.89296 10.3414 8.96764V15.6236C10.3414 15.7337 10.2871 15.8367 10.1962 15.8988C10.1053 15.9609 9.9896 15.9741 9.88703 15.9342L6.11459 14.4633C5.85863 14.3635 5.6901 14.1169 5.6901 13.8422V8.94887C5.6901 8.78195 5.62748 8.6211 5.51462 8.49812L0.175479 2.68004C0.0626124 2.55705 -6.15869e-06 2.39619 4.54316e-10 2.22926L5.66845e-05 0.697892ZM9.83867 8.30957H7.77604C7.59194 8.30957 7.4427 8.45881 7.4427 8.6429C7.4427 8.827 7.59194 8.97624 7.77604 8.97624H9.67478V15.1359L6.35677 13.8422V8.94887C6.35677 8.61503 6.23153 8.29333 6.00581 8.04736L0.666667 2.22929L0.666723 0.697917H15.3333V2.22301C13.6728 4.01502 10.9089 7.06494 10.035 8.03042C9.95758 8.11595 9.89189 8.20975 9.83867 8.30957Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4772_11659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutline);
export default __webpack_public_path__ + "static/media/filter-outline.8208ccb8eb2d2de375cbf516475994a6.svg";
export { ForwardRef as ReactComponent };